import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const OfficeAssetConfigLayout = () => {
  const navList = useNav();
  let { officeAssetsConfigBottom, officeAssetsConfigTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={officeAssetsConfigBottom} topTabs={officeAssetsConfigTopHeader} />
      <Outlet />
    </div>
  )
}

export default OfficeAssetConfigLayout
